module.exports = __webpack_public_path__ + "media/images/beauté des mains et des pieds-b2fb7acbd6f41cfd96600b5ffa976039.svg";